const AUD = [ 50, 100, 150, 200, 300 ];
const NZD = [ 50, 100, 150, 200, 300 ];
const EUR = [ 50, 100, 150, 200, 300 ];
const THB = [ 1000, 1500, 2500, 3500, 6000 ];
const MYR = [ 150, 220, 350, 450, 800 ];
const IDR = [ 500000, 700000, 1000000, 1500000, 2500000 ];

const PriceFilterRanges = { AUD, NZD, THB, MYR, IDR, EUR };

export { PriceFilterRanges };
